/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SummaryMode = typeof SummaryMode[keyof typeof SummaryMode];


export const SummaryMode = {
  bullets: 'bullets',
  paragraph: 'paragraph',
  detailed: 'detailed',
} as const;
